<div class="flex justify-start pl-13">
  <twaice-fe-svg-icon [twaiceFeTooltip]="data.text" source="tabler" name="info-circle" size="24px" />
</div>
